import { createRequestQueue } from './requestQueue';

const DEFAULT_DEBOUNCE_TIME = 5000; // 5 seconds
const requestQueue = createRequestQueue();

export class AutoSave {
  constructor(saveFunction, options = {}) {
    this.saveFunction = saveFunction;
    this.debounceTime = options.debounceTime || DEFAULT_DEBOUNCE_TIME;
    this.timer = null;
    this.lastSavePromise = Promise.resolve();
    this.pendingChanges = null;
  }

  // Schedule a save after the debounce period
  scheduleAutoSave(data) {
    this.pendingChanges = data;
    
    if (this.timer) {
      clearTimeout(this.timer);
    }

    this.timer = setTimeout(() => {
      this.save();
    }, this.debounceTime);
  }

  // Force an immediate save
  async forceSave() {
    if (this.timer) {
      clearTimeout(this.timer);
      this.timer = null;
    }

    return this.save();
  }

  // Internal save method
  async save() {
    if (!this.pendingChanges) {
      return;
    }

    const dataToSave = this.pendingChanges;
    this.pendingChanges = null;

    try {
      this.lastSavePromise = requestQueue.enqueue(() => 
        this.saveFunction(dataToSave)
      );
      await this.lastSavePromise;
      return true;
    } catch (error) {
      console.error('Auto-save failed:', error);
      // Put the changes back in pending if save failed
      this.pendingChanges = dataToSave;
      throw error;
    }
  }

  // Handle blur events
  handleBlur = () => {
    if (this.pendingChanges) {
      this.forceSave();
    }
  }

  // Clean up timers
  destroy() {
    if (this.timer) {
      clearTimeout(this.timer);
      this.timer = null;
    }
  }
}

// Create an auto-save instance with a save function and optional options
export const createAutoSave = (saveFunction, options = {}) => {
  return new AutoSave(saveFunction, options);
};